// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiTextItem-module__font-s-10___FbrQ3 {
  font-size: 10px !important;
}

.MultiTextItem-module__font-s-12___oRw9C {
  font-size: 12px !important;
}

.MultiTextItem-module__font-s-13___nI1JP {
  font-size: 13px !important;
}

.MultiTextItem-module__font-s-14___Tvuhi {
  font-size: 14px !important;
}

.MultiTextItem-module__font-s-15___jKg6e {
  font-size: 15px !important;
}

.MultiTextItem-module__font-s-16___HZwHt {
  font-size: 16px !important;
}

.MultiTextItem-module__font-s-18___S_kd2 {
  font-size: 18px !important;
}

.MultiTextItem-module__font-s-20___ZkJRc {
  font-size: 20px !important;
}

.MultiTextItem-module__font-s-22___snSCP {
  font-size: 22px !important;
}

.MultiTextItem-module__font-s-28___BEm9z {
  font-size: 28px !important;
}

.MultiTextItem-module__font-w-400___NwTKG {
  font-weight: 400 !important;
}

.MultiTextItem-module__font-w-500___KwoWD {
  font-weight: 500 !important;
}

.MultiTextItem-module__font-w-600___Y4aSY {
  font-weight: 600 !important;
}

.MultiTextItem-module__font-w-700___a5SOf {
  font-weight: 700 !important;
}

.MultiTextItem-module__p-5___Zbysv {
  padding: 5px !important;
}

.MultiTextItem-module__p-12___lbvjn {
  padding: 12px !important;
}

.MultiTextItem-module__p-16___yquu2 {
  padding: 16px !important;
}

.MultiTextItem-module__p-30___fr42p {
  padding: 30px !important;
}

.MultiTextItem-module__p-b-0___H1QO_ {
  padding-bottom: 0 !important;
}

.MultiTextItem-module__p-b-5___TVG4M {
  padding-bottom: 5px !important;
}

.MultiTextItem-module__p-b-10___eVh8A {
  padding-bottom: 10px !important;
}

.MultiTextItem-module__p-b-12___yse9w {
  padding-bottom: 12px !important;
}

.MultiTextItem-module__p-b-16___sFWYG {
  padding-bottom: 16px !important;
}

.MultiTextItem-module__p-b-18___ZGl5g {
  padding-bottom: 18px !important;
}

.MultiTextItem-module__p-b-20___1c1wS {
  padding-bottom: 20px !important;
}

.MultiTextItem-module__p-b-25___Dp08t {
  padding-bottom: 25px !important;
}

.MultiTextItem-module__p-b-30___wQp_B {
  padding-bottom: 30px !important;
}

.MultiTextItem-module__p-b-50___kRUSj {
  padding-bottom: 50px !important;
}

.MultiTextItem-module__p-t-0___jixQL {
  padding-top: 0 !important;
}

.MultiTextItem-module__p-t-12___XCZOb {
  padding-top: 12px !important;
}

.MultiTextItem-module__p-t-16___hyxMX {
  padding-top: 16px !important;
}

.MultiTextItem-module__p-t-18___Q39_7 {
  padding-top: 18px !important;
}

.MultiTextItem-module__p-t-20___IlpSm {
  padding-top: 20px !important;
}

.MultiTextItem-module__p-t-30___Vct9S {
  padding-top: 30px !important;
}

.MultiTextItem-module__p-t-40___saNAN {
  padding-top: 40px !important;
}

.MultiTextItem-module__p-t-50___GIVOE {
  padding-top: 50px !important;
}

.MultiTextItem-module__p-l-20___FvgPe {
  padding-left: 20px !important;
}

.MultiTextItem-module__p-l-30___Wp31d {
  padding-left: 30px !important;
}

.MultiTextItem-module__p-l-40___cSoee {
  padding-left: 40px !important;
}

.MultiTextItem-module__p-r-16___OJv00 {
  padding-right: 16px !important;
}

.MultiTextItem-module__p-r-20___FH4JM {
  padding-right: 20px !important;
}

.MultiTextItem-module__p-r-30___aDBHt {
  padding-right: 30px !important;
}

.MultiTextItem-module__p-r-50___wAPQ9 {
  padding-right: 50px !important;
}

.MultiTextItem-module__p-r-60___DYOnX {
  padding-right: 60px !important;
}

.MultiTextItem-module__m-b-1___sMYjK {
  margin-bottom: 1px !important;
}

.MultiTextItem-module__m-b-2___ZcVOK {
  margin-bottom: 2px !important;
}

.MultiTextItem-module__m-b-6___ya2RJ {
  margin-bottom: 6px !important;
}

.MultiTextItem-module__m-b-8___JnPpR {
  margin-bottom: 8px !important;
}

.MultiTextItem-module__m-b-10___DP4ko {
  margin-bottom: 10px !important;
}

.MultiTextItem-module__m-b-14___ZtUpA {
  margin-bottom: 14px !important;
}

.MultiTextItem-module__m-b-16___ULloQ {
  margin-bottom: 16px !important;
}

.MultiTextItem-module__m-b-20___X2VKm {
  margin-bottom: 20px !important;
}

.MultiTextItem-module__m-b-22___IT25D {
  margin-bottom: 22px !important;
}

.MultiTextItem-module__m-b-24___Jhut4 {
  margin-bottom: 24px !important;
}

.MultiTextItem-module__m-b-30___AruA2 {
  margin-bottom: 30px !important;
}

.MultiTextItem-module__m-b-32___sJ4YP {
  margin-bottom: 32px !important;
}

.MultiTextItem-module__m-b-40___tWUn8 {
  margin-bottom: 40px !important;
}

.MultiTextItem-module__m-t-2___h8zYK {
  margin-top: 2px !important;
}

.MultiTextItem-module__m-t-3___V9xgO {
  margin-top: 3px !important;
}

.MultiTextItem-module__m-t-4___rbFGL {
  margin-top: 4px !important;
}

.MultiTextItem-module__m-t-5___fegCB {
  margin-top: 5px !important;
}

.MultiTextItem-module__m-t-8___MNvGF {
  margin-top: 8px !important;
}

.MultiTextItem-module__m-t-10___lhS48 {
  margin-top: 10px !important;
}

.MultiTextItem-module__m-t-15___ZEWjM {
  margin-top: 15px !important;
}

.MultiTextItem-module__m-t-16___Kn2E2 {
  margin-top: 16px !important;
}

.MultiTextItem-module__m-t-20___LbFIr {
  margin-top: 20px !important;
}

.MultiTextItem-module__m-t-22___XBkKd {
  margin-top: 22px !important;
}

.MultiTextItem-module__m-t-30___VWACR {
  margin-top: 30px !important;
}

.MultiTextItem-module__m-t-32___K1gNl {
  margin-top: 32px !important;
}

.MultiTextItem-module__m-l-auto___PZGOs {
  margin-left: auto !important;
}

.MultiTextItem-module__m-l-4___WlT_5 {
  margin-left: 4px !important;
}

.MultiTextItem-module__m-l-5___iUwHd {
  margin-left: 5px !important;
}

.MultiTextItem-module__m-l-6___Q_f1Y {
  margin-left: 6px !important;
}

.MultiTextItem-module__m-l-8___XKDfT {
  margin-left: 8px !important;
}

.MultiTextItem-module__m-l-10___i1d6X {
  margin-left: 10px !important;
}

.MultiTextItem-module__m-l-16___A02ba {
  margin-left: 16px !important;
}

.MultiTextItem-module__m-l-20___pnIo4 {
  margin-left: 20px !important;
}

.MultiTextItem-module__m-l-24___Th4MT {
  margin-left: 24px !important;
}

.MultiTextItem-module__m-l-30___eNaB9 {
  margin-left: 30px !important;
}

.MultiTextItem-module__m-l-35___SM0tB {
  margin-left: 35px !important;
}

.MultiTextItem-module__m-l-40___NsQ80 {
  margin-left: 40px !important;
}

.MultiTextItem-module__m-r-8___KmAwa {
  margin-right: 8px !important;
}

.MultiTextItem-module__m-r-10___xLIFC {
  margin-right: 10px !important;
}

.MultiTextItem-module__m-r-16___cF_Cv {
  margin-right: 16px !important;
}

.MultiTextItem-module__m-r-20___vcDVP {
  margin-right: 20px !important;
}

.MultiTextItem-module__m-r-24___WqNhU {
  margin-right: 24px !important;
}

.MultiTextItem-module__m-r-30___rNrGE {
  margin-right: 30px !important;
}

.MultiTextItem-module__m-r-40___rTN_0 {
  margin-right: 40px !important;
}

.MultiTextItem-module__border-r-3___yCxXU {
  border-radius: 3px !important;
}

.MultiTextItem-module__border-r-4___ke8sB {
  border-radius: 4px !important;
}

.MultiTextItem-module__border-r-6___M5jZf {
  border-radius: 6px !important;
}

.MultiTextItem-module__border-r-10___WCftV {
  border-radius: 10px !important;
}

.MultiTextItem-module__border-r-12___f_x2M {
  border-radius: 12px !important;
}

.MultiTextItem-module__border-r-16___KZH2Q {
  border-radius: 16px !important;
}

.MultiTextItem-module__border-r-50___qJVz1 {
  border-radius: 50% !important;
}

.MultiTextItem-module__primary-border___ItF2c {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MultiTextItem-module__primary-border-b___jFnKT {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MultiTextItem-module__primary-border-t___T57e5 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MultiTextItem-module__primary-border-l___ZW_Qt {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MultiTextItem-module__primary-border-r___pY4Fk {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MultiTextItem-module__secondary-border___zBUGx {
  border: 1px solid #637768;
}

.MultiTextItem-module__secondary-border-b___aLRkM {
  border-bottom: 1px solid #637768;
}

.MultiTextItem-module__secondary-border-t___usFZz {
  border-top: 1px solid #637768;
}

.MultiTextItem-module__secondary-border-l___OMA94 {
  border-left: 1px solid #637768;
}

.MultiTextItem-module__secondary-border-r___V6GWh {
  border-right: 1px solid #637768;
}

.MultiTextItem-module__gap-0___AzGGx {
  gap: 0 !important;
}

.MultiTextItem-module__gap-2___K3Yml {
  gap: 2px !important;
}

.MultiTextItem-module__gap-4___pFCzW {
  gap: 4px !important;
}

.MultiTextItem-module__gap-5___PKvug {
  gap: 5px !important;
}

.MultiTextItem-module__gap-6___ri7cS {
  gap: 6px !important;
}

.MultiTextItem-module__gap-8___XprjR {
  gap: 8px !important;
}

.MultiTextItem-module__gap-10___CXggL {
  gap: 10px !important;
}

.MultiTextItem-module__gap-12___TOoPZ {
  gap: 12px !important;
}

.MultiTextItem-module__gap-14___ZBwTq {
  gap: 14px !important;
}

.MultiTextItem-module__gap-16___wMw6v {
  gap: 16px !important;
}

.MultiTextItem-module__gap-18___Ruwr_ {
  gap: 18px !important;
}

.MultiTextItem-module__gap-20___GQheE {
  gap: 20px !important;
}

.MultiTextItem-module__gap-24____SSBx {
  gap: 24px !important;
}

.MultiTextItem-module__gap-26___lWTd9 {
  gap: 26px !important;
}

.MultiTextItem-module__gap-30___BVzWb {
  gap: 30px !important;
}

.MultiTextItem-module__gap-32___xevdG {
  gap: 32px !important;
}

.MultiTextItem-module__gap-40___RWUNA {
  gap: 40px !important;
}

.MultiTextItem-module__gap-50___O8Gfl {
  gap: 50px !important;
}

.MultiTextItem-module__flex-1___hhgfQ {
  flex: 1;
}

.MultiTextItem-module__flex-none___ldbij {
  flex: none !important;
}

.MultiTextItem-module__flex-column___p7Jo1 {
  display: flex;
  flex-direction: column !important;
}

.MultiTextItem-module__flex-row___bxmfr {
  display: flex;
  flex-direction: row !important;
}

.MultiTextItem-module__vertically-centered___ACd_D {
  display: flex;
  align-items: center !important;
}

.MultiTextItem-module__horizontally-centered___Ht5or {
  display: flex;
  justify-content: center !important;
}

.MultiTextItem-module__horizontally-end___k9Kho {
  display: flex;
  justify-content: end !important;
}

.MultiTextItem-module__vertically-start___BD3S8 {
  display: flex;
  align-items: start !important;
}

.MultiTextItem-module__space-between___omFnN {
  display: flex;
  justify-content: space-between !important;
}

.MultiTextItem-module__flex-wrap___GT5OP {
  flex-wrap: wrap !important;
}

.MultiTextItem-module__height-100___t8PUB {
  height: 100%;
}

.MultiTextItem-module__width-50___ejZfn {
  width: 50% !important;
}

.MultiTextItem-module__width-100___PD5Br {
  width: 100%;
}

.MultiTextItem-module__cursor-pointer___NIqck {
  cursor: pointer;
}

.MultiTextItem-module__cursor-not-allowed___PAZT1 {
  cursor: not-allowed !important;
}

.MultiTextItem-module__absolute-centered___ab92h {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MultiTextItem-module__absolute___h_JKn {
  position: absolute;
}

.MultiTextItem-module__relative___WPsh9 {
  position: relative;
}

.MultiTextItem-module__fixed___bsXzF {
  position: fixed;
}

.MultiTextItem-module__visible___yBcH_ {
  opacity: 1;
}

.MultiTextItem-module__invisible___m6KmB {
  opacity: 0;
}

.MultiTextItem-module__col-90___fi_1F {
  width: 90% !important;
}

.MultiTextItem-module__col-auto___ZDkld {
  width: auto !important;
}

.MultiTextItem-module__medical-tabs___IFj9g {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MultiTextItem-module__medical-table-new___HzICY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MultiTextItem-module__medical-table-new___HzICY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MultiTextItem-module__medical-table-new___HzICY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MultiTextItem-module__medical-table-new___HzICY::-webkit-scrollbar-track {
  display: none;
}
.MultiTextItem-module__medical-table-new___HzICY.MultiTextItem-module__no-pagination___uh19j {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MultiTextItem-module__medical-table-new___HzICY.MultiTextItem-module__no-pagination___uh19j:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MultiTextItem-module__medical-table-new___HzICY.MultiTextItem-module__no-pagination___uh19j::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MultiTextItem-module__medical-table-new___HzICY.MultiTextItem-module__no-pagination___uh19j::-webkit-scrollbar-track {
  display: none;
}

.MultiTextItem-module__medical-table-empty___cblYn {
  padding: 14px 40px !important;
}

.MultiTextItem-module__icon-btn___jfUiE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MultiTextItem-module__search-icon___LheaG {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MultiTextItem-module__disable-select___CTjBM {
  user-select: none;
}

.MultiTextItem-module__break-word___Ewp9i {
  word-break: break-word;
}

.MultiTextItem-module__popup-clear-btn___YQREN {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MultiTextItem-module__scroll-m-b-20___RDWg1 {
  scroll-margin-bottom: 20px;
}

.MultiTextItem-module__container___SS0So {
  flex: 1;
  max-width: 97%;
  cursor: pointer;
}
.MultiTextItem-module__container___SS0So .MultiTextItem-module__title___H43JO {
  height: 20px;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #375844;
  letter-spacing: -0.011em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.MultiTextItem-module__container___SS0So .MultiTextItem-module__subtitle___sX_Dw {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  letter-spacing: -0.011em;
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/MultiTextItem/MultiTextItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,cAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,YAAA;EEkBF,+BApBO;EAqBP,gBAFmD;EFfjD,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA+pBJ;AA5pBE;EEQA,+BApBO;EAqBP,gBAFmD;EFLjD,iBAAA;EACA,wBAAA;EACA,cAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  max-width: 97%;\n  cursor: pointer;\n\n  .title {\n    height: 20px;\n    @include get-font($roboto);\n    line-height: 150%;\n    color: get-color(greenNew, dark);\n    letter-spacing: -0.011em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .subtitle {\n    @include get-font($roboto);\n    line-height: 15px;\n    letter-spacing: -0.011em;\n    color: get-color(greenNew, medium);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MultiTextItem-module__font-s-10___FbrQ3`,
	"fontS12": `MultiTextItem-module__font-s-12___oRw9C`,
	"fontS13": `MultiTextItem-module__font-s-13___nI1JP`,
	"fontS14": `MultiTextItem-module__font-s-14___Tvuhi`,
	"fontS15": `MultiTextItem-module__font-s-15___jKg6e`,
	"fontS16": `MultiTextItem-module__font-s-16___HZwHt`,
	"fontS18": `MultiTextItem-module__font-s-18___S_kd2`,
	"fontS20": `MultiTextItem-module__font-s-20___ZkJRc`,
	"fontS22": `MultiTextItem-module__font-s-22___snSCP`,
	"fontS28": `MultiTextItem-module__font-s-28___BEm9z`,
	"fontW400": `MultiTextItem-module__font-w-400___NwTKG`,
	"fontW500": `MultiTextItem-module__font-w-500___KwoWD`,
	"fontW600": `MultiTextItem-module__font-w-600___Y4aSY`,
	"fontW700": `MultiTextItem-module__font-w-700___a5SOf`,
	"p5": `MultiTextItem-module__p-5___Zbysv`,
	"p12": `MultiTextItem-module__p-12___lbvjn`,
	"p16": `MultiTextItem-module__p-16___yquu2`,
	"p30": `MultiTextItem-module__p-30___fr42p`,
	"pB0": `MultiTextItem-module__p-b-0___H1QO_`,
	"pB5": `MultiTextItem-module__p-b-5___TVG4M`,
	"pB10": `MultiTextItem-module__p-b-10___eVh8A`,
	"pB12": `MultiTextItem-module__p-b-12___yse9w`,
	"pB16": `MultiTextItem-module__p-b-16___sFWYG`,
	"pB18": `MultiTextItem-module__p-b-18___ZGl5g`,
	"pB20": `MultiTextItem-module__p-b-20___1c1wS`,
	"pB25": `MultiTextItem-module__p-b-25___Dp08t`,
	"pB30": `MultiTextItem-module__p-b-30___wQp_B`,
	"pB50": `MultiTextItem-module__p-b-50___kRUSj`,
	"pT0": `MultiTextItem-module__p-t-0___jixQL`,
	"pT12": `MultiTextItem-module__p-t-12___XCZOb`,
	"pT16": `MultiTextItem-module__p-t-16___hyxMX`,
	"pT18": `MultiTextItem-module__p-t-18___Q39_7`,
	"pT20": `MultiTextItem-module__p-t-20___IlpSm`,
	"pT30": `MultiTextItem-module__p-t-30___Vct9S`,
	"pT40": `MultiTextItem-module__p-t-40___saNAN`,
	"pT50": `MultiTextItem-module__p-t-50___GIVOE`,
	"pL20": `MultiTextItem-module__p-l-20___FvgPe`,
	"pL30": `MultiTextItem-module__p-l-30___Wp31d`,
	"pL40": `MultiTextItem-module__p-l-40___cSoee`,
	"pR16": `MultiTextItem-module__p-r-16___OJv00`,
	"pR20": `MultiTextItem-module__p-r-20___FH4JM`,
	"pR30": `MultiTextItem-module__p-r-30___aDBHt`,
	"pR50": `MultiTextItem-module__p-r-50___wAPQ9`,
	"pR60": `MultiTextItem-module__p-r-60___DYOnX`,
	"mB1": `MultiTextItem-module__m-b-1___sMYjK`,
	"mB2": `MultiTextItem-module__m-b-2___ZcVOK`,
	"mB6": `MultiTextItem-module__m-b-6___ya2RJ`,
	"mB8": `MultiTextItem-module__m-b-8___JnPpR`,
	"mB10": `MultiTextItem-module__m-b-10___DP4ko`,
	"mB14": `MultiTextItem-module__m-b-14___ZtUpA`,
	"mB16": `MultiTextItem-module__m-b-16___ULloQ`,
	"mB20": `MultiTextItem-module__m-b-20___X2VKm`,
	"mB22": `MultiTextItem-module__m-b-22___IT25D`,
	"mB24": `MultiTextItem-module__m-b-24___Jhut4`,
	"mB30": `MultiTextItem-module__m-b-30___AruA2`,
	"mB32": `MultiTextItem-module__m-b-32___sJ4YP`,
	"mB40": `MultiTextItem-module__m-b-40___tWUn8`,
	"mT2": `MultiTextItem-module__m-t-2___h8zYK`,
	"mT3": `MultiTextItem-module__m-t-3___V9xgO`,
	"mT4": `MultiTextItem-module__m-t-4___rbFGL`,
	"mT5": `MultiTextItem-module__m-t-5___fegCB`,
	"mT8": `MultiTextItem-module__m-t-8___MNvGF`,
	"mT10": `MultiTextItem-module__m-t-10___lhS48`,
	"mT15": `MultiTextItem-module__m-t-15___ZEWjM`,
	"mT16": `MultiTextItem-module__m-t-16___Kn2E2`,
	"mT20": `MultiTextItem-module__m-t-20___LbFIr`,
	"mT22": `MultiTextItem-module__m-t-22___XBkKd`,
	"mT30": `MultiTextItem-module__m-t-30___VWACR`,
	"mT32": `MultiTextItem-module__m-t-32___K1gNl`,
	"mLAuto": `MultiTextItem-module__m-l-auto___PZGOs`,
	"mL4": `MultiTextItem-module__m-l-4___WlT_5`,
	"mL5": `MultiTextItem-module__m-l-5___iUwHd`,
	"mL6": `MultiTextItem-module__m-l-6___Q_f1Y`,
	"mL8": `MultiTextItem-module__m-l-8___XKDfT`,
	"mL10": `MultiTextItem-module__m-l-10___i1d6X`,
	"mL16": `MultiTextItem-module__m-l-16___A02ba`,
	"mL20": `MultiTextItem-module__m-l-20___pnIo4`,
	"mL24": `MultiTextItem-module__m-l-24___Th4MT`,
	"mL30": `MultiTextItem-module__m-l-30___eNaB9`,
	"mL35": `MultiTextItem-module__m-l-35___SM0tB`,
	"mL40": `MultiTextItem-module__m-l-40___NsQ80`,
	"mR8": `MultiTextItem-module__m-r-8___KmAwa`,
	"mR10": `MultiTextItem-module__m-r-10___xLIFC`,
	"mR16": `MultiTextItem-module__m-r-16___cF_Cv`,
	"mR20": `MultiTextItem-module__m-r-20___vcDVP`,
	"mR24": `MultiTextItem-module__m-r-24___WqNhU`,
	"mR30": `MultiTextItem-module__m-r-30___rNrGE`,
	"mR40": `MultiTextItem-module__m-r-40___rTN_0`,
	"borderR3": `MultiTextItem-module__border-r-3___yCxXU`,
	"borderR4": `MultiTextItem-module__border-r-4___ke8sB`,
	"borderR6": `MultiTextItem-module__border-r-6___M5jZf`,
	"borderR10": `MultiTextItem-module__border-r-10___WCftV`,
	"borderR12": `MultiTextItem-module__border-r-12___f_x2M`,
	"borderR16": `MultiTextItem-module__border-r-16___KZH2Q`,
	"borderR50": `MultiTextItem-module__border-r-50___qJVz1`,
	"primaryBorder": `MultiTextItem-module__primary-border___ItF2c`,
	"primaryBorderB": `MultiTextItem-module__primary-border-b___jFnKT`,
	"primaryBorderT": `MultiTextItem-module__primary-border-t___T57e5`,
	"primaryBorderL": `MultiTextItem-module__primary-border-l___ZW_Qt`,
	"primaryBorderR": `MultiTextItem-module__primary-border-r___pY4Fk`,
	"secondaryBorder": `MultiTextItem-module__secondary-border___zBUGx`,
	"secondaryBorderB": `MultiTextItem-module__secondary-border-b___aLRkM`,
	"secondaryBorderT": `MultiTextItem-module__secondary-border-t___usFZz`,
	"secondaryBorderL": `MultiTextItem-module__secondary-border-l___OMA94`,
	"secondaryBorderR": `MultiTextItem-module__secondary-border-r___V6GWh`,
	"gap0": `MultiTextItem-module__gap-0___AzGGx`,
	"gap2": `MultiTextItem-module__gap-2___K3Yml`,
	"gap4": `MultiTextItem-module__gap-4___pFCzW`,
	"gap5": `MultiTextItem-module__gap-5___PKvug`,
	"gap6": `MultiTextItem-module__gap-6___ri7cS`,
	"gap8": `MultiTextItem-module__gap-8___XprjR`,
	"gap10": `MultiTextItem-module__gap-10___CXggL`,
	"gap12": `MultiTextItem-module__gap-12___TOoPZ`,
	"gap14": `MultiTextItem-module__gap-14___ZBwTq`,
	"gap16": `MultiTextItem-module__gap-16___wMw6v`,
	"gap18": `MultiTextItem-module__gap-18___Ruwr_`,
	"gap20": `MultiTextItem-module__gap-20___GQheE`,
	"gap24": `MultiTextItem-module__gap-24____SSBx`,
	"gap26": `MultiTextItem-module__gap-26___lWTd9`,
	"gap30": `MultiTextItem-module__gap-30___BVzWb`,
	"gap32": `MultiTextItem-module__gap-32___xevdG`,
	"gap40": `MultiTextItem-module__gap-40___RWUNA`,
	"gap50": `MultiTextItem-module__gap-50___O8Gfl`,
	"flex1": `MultiTextItem-module__flex-1___hhgfQ`,
	"flexNone": `MultiTextItem-module__flex-none___ldbij`,
	"flexColumn": `MultiTextItem-module__flex-column___p7Jo1`,
	"flexRow": `MultiTextItem-module__flex-row___bxmfr`,
	"verticallyCentered": `MultiTextItem-module__vertically-centered___ACd_D`,
	"horizontallyCentered": `MultiTextItem-module__horizontally-centered___Ht5or`,
	"horizontallyEnd": `MultiTextItem-module__horizontally-end___k9Kho`,
	"verticallyStart": `MultiTextItem-module__vertically-start___BD3S8`,
	"spaceBetween": `MultiTextItem-module__space-between___omFnN`,
	"flexWrap": `MultiTextItem-module__flex-wrap___GT5OP`,
	"height100": `MultiTextItem-module__height-100___t8PUB`,
	"width50": `MultiTextItem-module__width-50___ejZfn`,
	"width100": `MultiTextItem-module__width-100___PD5Br`,
	"cursorPointer": `MultiTextItem-module__cursor-pointer___NIqck`,
	"cursorNotAllowed": `MultiTextItem-module__cursor-not-allowed___PAZT1`,
	"absoluteCentered": `MultiTextItem-module__absolute-centered___ab92h`,
	"absolute": `MultiTextItem-module__absolute___h_JKn`,
	"relative": `MultiTextItem-module__relative___WPsh9`,
	"fixed": `MultiTextItem-module__fixed___bsXzF`,
	"visible": `MultiTextItem-module__visible___yBcH_`,
	"invisible": `MultiTextItem-module__invisible___m6KmB`,
	"col90": `MultiTextItem-module__col-90___fi_1F`,
	"colAuto": `MultiTextItem-module__col-auto___ZDkld`,
	"medicalTabs": `MultiTextItem-module__medical-tabs___IFj9g`,
	"medicalTableNew": `MultiTextItem-module__medical-table-new___HzICY`,
	"noPagination": `MultiTextItem-module__no-pagination___uh19j`,
	"medicalTableEmpty": `MultiTextItem-module__medical-table-empty___cblYn`,
	"iconBtn": `MultiTextItem-module__icon-btn___jfUiE`,
	"searchIcon": `MultiTextItem-module__search-icon___LheaG`,
	"disableSelect": `MultiTextItem-module__disable-select___CTjBM`,
	"breakWord": `MultiTextItem-module__break-word___Ewp9i`,
	"popupClearBtn": `MultiTextItem-module__popup-clear-btn___YQREN`,
	"scrollMB20": `MultiTextItem-module__scroll-m-b-20___RDWg1`,
	"container": `MultiTextItem-module__container___SS0So`,
	"title": `MultiTextItem-module__title___H43JO`,
	"subtitle": `MultiTextItem-module__subtitle___sX_Dw`
};
module.exports = ___CSS_LOADER_EXPORT___;
